const customerActions = {
    GET_REPORTS: 'GET_REPORTS',
    SET_REPORTS: 'SET_REPORTS',

    GET_PAYMENT_HISTORY: 'GET_PAYMENT_HISTORY',
    SET_PAYMENT_HISTORY: 'SET_PAYMENT_HISTORY',

    GET_APPLICATION_STATUS: 'GET_APPLICATION_STATUS',
    SET_APPLICATION_STATUS: 'SET_APPLICATION_STATUS',

    GET_SEARCH_CANDIDATE: 'GET_SEARCH_CANDIDATE',
    SET_SEARCH_CANDIDATE: 'SET_SEARCH_CANDIDATE',

    GET_GENERATE_REPORT: 'GET_GENERATE_REPORT',
    SET_GENERATE_REPORT: 'SET_GENERATE_REPORT',

    GET_DATEWISE_REPORT: 'GET_DATEWISE_REPORT',
    SET_DATEWISE_REPORT: 'SET_DATEWISE_REPORT',

    GET_CONSOLIDATE_REPORT: 'GET_CONSOLIDATE_REPORT',
    SET_CONSOLIDATE_REPORT: 'SET_CONSOLIDATE_REPORT',

    GET_NOOFATTEMPTS_REPORT: 'GET_NOOFATTEMPTS_REPORT',
    SET_NOOFATTEMPTS_REPORT: 'SET_NOOFATTEMPTS_REPORT',

    GET_GENDERCATEGEORY_REPORT: 'GET_GENDERCATEGEORY_REPORT',
    SET_GENDERCATEGEORY_REPORT: 'SET_GENDERCATEGEORY_REPORT',

    GET_OBJECTIONTRACK_REPORT: 'GET_OBJECTIONTRACK_REPORT',
    SET_OBJECTIONTRACK_REPORT: 'SET_OBJECTIONTRACK_REPORT',

    GET_OBJECTION_PAYMENT_REPORT: 'GET_OBJECTION_PAYMENT_REPORT',
    SET_OBJECTION_PAYMENT_REPORT: 'SET_OBJECTION_PAYMENT_REPORT',

    GET_UNIQUE_OBJECTION_REPORT: 'GET_UNIQUE_OBJECTION_REPORT',
    SET_UNIQUE_OBJECTION_REPORT: 'SET_UNIQUE_OBJECTION_REPORT',

    GET_PREFERENCEWISE_REPORT: 'GET_PREFERENCEWISE_REPORT',
    SET_PREFERENCEWISE_REPORT: 'SET_PREFERENCEWISE_REPORT',
    GET_ALL_COURSES_PREFERENCEWISE_REPORT: 'GET_ALL_COURSES_PREFERENCEWISE_REPORT',

    UPLOAD_RECONCILIATION_FILE: 'UPLOAD_RECONCILIATION_FILE',
    GET_RECONCILIATION_REPORT: 'GET_RECONCILIATION_REPORT',
    SET_RECONCILIATION_REPORT: 'SET_RECONCILIATION_REPORT',
    GET_LATEST_DB_DUMP: 'GET_LATEST_DB_DUMP',
    OVERRIDE_RECONCILIATION_STATUS: 'OVERRIDE_RECONCILIATION_STATUS',
    OVERRIDE_RECONCILIATION_SUCCESS: 'OVERRIDE_RECONCILIATION_SUCCESS',
    DOWNLOAD_RECONCILIATION_REPORT: 'DOWNLOAD_RECONCILIATION_REPORT',

    GET_VBSA_REPORT: 'GET_VBSA_REPORT',
    SET_VBSA_REPORT: 'SET_VBSA_REPORT',

    GET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES: 'GET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES',
    SET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES: 'SET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES',

};

export default customerActions;